import { Badge, Box, Flex, Heading, Text, Link as ChakraLink, Stack, Avatar } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'
import { BreadcrumbType } from '@/Types/types'
import Breadcrumbs from '@/components/Breadcrumbs'

interface Props {
  data: any
  breadcrumbs: BreadcrumbType[]
}

export default function BreedBanner({ data, breadcrumbs }: Props) {
  return (
    <Box
      as="section"
      flexDirection={{ base: "column", lg: "row" }}
      width="100%"
      paddingBottom="0"
      paddingTop={{ base: "0", lg: "80px" }}
    >
      <Flex
        direction="column"
        maxWidth="1216px"
        width="90%"
        margin="0 auto"
        p={{ base: "24px 0 24px 0", lg: "0" }}
        gap={{ base: "16px", lg: "0px" }}
      >
        <Breadcrumbs data={breadcrumbs} />
        <Flex p={{ base: "32px 0 0 0", lg: "80px 0" }} gap="32px" direction={{ base: "column-reverse", lg: "row" }}>
          <Flex direction="column" gap={{ base: "16px", lg: "32px" }} width={{ base: "100%", lg: "592px" }}>
            <Flex gap="8px" flexWrap="wrap">
              {data.attributes.category.data.map((item: any, i: number) => (
                <Badge
                  key={i}
                  textTransform="none"
                  bgColor={item.attributes.bgColor}
                  color={item.attributes.color}
                  width="fit-content"
                >
                  {item.attributes.title}
                </Badge>
              ))}
            </Flex>
            <Heading
              as="h1"
              fontSize={{ base: "30px", lg: "48px" }}
              lineHeight={{ base: "36px", lg: "48px" }}
              fontWeight="800"
              color="gray.800"
            >
              {data.attributes.name}
            </Heading>
            <Heading
              as="h2"
              fontSize={{ base: "16px", lg: "24px" }}
              lineHeight={{ base: "24px", lg: "32px" }}
              fontWeight="600"
              color="gray.500"
            >
              {data.attributes.knownName}
            </Heading>
            <Text
              fontSize={{ base: "18px", lg: "18px" }}
              lineHeight="28px"
              color="gray.600"
            >
              {data.attributes.description}
            </Text>
            <Stack alignSelf="stretch" direction="row" justify="flex-start" align="center" spacing="16px" mt={{ base: "16px", lg: "0px" }}>
              <Avatar
                width={{ base: "48px", lg: "64px" }}
                height={{ base: "48px", lg: "64px" }}
                name={data.attributes.author.data.attributes.name}
                src={data.attributes.author.data.attributes.img?.data.attributes.url}
              />
              <ChakraLink
                as={Link}
                href={`/blog/perfil/${data.attributes.author.data.attributes.url}`}
              >
                <Text
                  fontSize="12px"
                  lineHeight="16px"
                  color="gray.700"
                >
                  Conteúdo revisado por
                </Text>
                <Text
                  fontSize="14px"
                  lineHeight="20px"
                  fontWeight="500"
                  color="gray.700"
                  textDecoration="none"
                  w="auto"
                  p="0 !important"
                  _hover={{
                    textDecoration: 'none',
                  }}
                >
                  {data.attributes.author.data.attributes.name}
                </Text>

              </ChakraLink>
            </Stack>
          </Flex>
          <Box
            width={{ base: "100%", lg: "592px" }}
            height={{ base: "236px", lg: "410px" }}
            position="relative"
            borderRadius="8px 32px 32px 32px"
            overflow="hidden"
          >
            <Image
              priority
              fill
              src={data.attributes.image.data.attributes.url}
              alt={data.attributes.name}
              style={{ objectFit: "cover", position: "absolute" }}
            />
          </Box>
        </Flex>
      </Flex>
    </Box>
  )
}
